export default {
  all: [
    {
      name: '#TG3425',
      status: 'Active',
      id: 1
    },
    {
      name: '#FG3424',
      status: 'Active',
      id: 2
    },
    {
      name: '#AG3242',
      status: 'Active',
      id: 3
    }
  ]
}
